import { render, staticRenderFns } from "./DurationField.vue?vue&type=template&id=39526d94&scoped=true"
import script from "./DurationField.vue?vue&type=script&lang=js"
export * from "./DurationField.vue?vue&type=script&lang=js"
import style0 from "./DurationField.vue?vue&type=style&index=0&id=39526d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39526d94",
  null
  
)

export default component.exports